class MblScentFamily extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll("[data-scent-family-tab]"));
    this.panels = Array.from(this.querySelectorAll("[data-scent-family-panel]"));

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => this.activate(tab.dataset.scentFamilyTab));
    });
  }

  activate(id) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.scentFamilyTab === id;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.scentFamilyPanel === id;

      if (active) {
        panel.hidden = false;
        requestAnimationFrame(() => panel.classList.add("is-active"));
      } else {
        panel.classList.remove("is-active");
        window.setTimeout(() => {
          if (!panel.classList.contains("is-active")) panel.hidden = true;
        }, 260);
      }
    });
  }
}

if (!customElements.get("mbl-scent-family")) {
  customElements.define("mbl-scent-family", MblScentFamily);
}
